module.exports = __webpack_public_path__ + "img/haters-3.ea006ae9.png";